import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/content/landing";
import Dashboard from "@/pages/Dashboard";
import ReportPage from "@/pages/ReportPage";
import Landing from "@/pages/Landing";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Agb from "@/pages/Agb";
import Widerruf from "@/pages/Widerruf";
import Quote from "@/pages/Quote";
import Login from "@/pages/Login";
import { AnalysisWizard } from "@/components/analyse/AnalysisWizard";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Inbox from "@/pages/admin/Inbox";
import Services from "@/pages/admin/Services";
import Discounts from "@/pages/admin/Discounts";
import Pages from "@/pages/admin/Pages";
import Orders from "@/pages/admin/Orders";
import Backfill from "@/pages/admin/Backfill";
import KeywordSets from "@/pages/admin/KeywordSets";
import Testimonials from "@/pages/admin/Testimonials";

// LanguageProvider (de/en/tr, user-chosen) scopes only the public marketing
// site — ReportPage has its own separate DE/EN system driven by the
// business's own country (see ReportPage.js's `lang`/`T`), and Dashboard is
// the Turkish-language internal admin tool. The two must not collide.
function PublicSite({ children }) {
  return <LanguageProvider>{children}</LanguageProvider>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite><Landing /></PublicSite>} />
          <Route path="/impressum" element={<PublicSite><Impressum /></PublicSite>} />
          <Route path="/datenschutz" element={<PublicSite><Datenschutz /></PublicSite>} />
          <Route path="/agb" element={<PublicSite><Agb /></PublicSite>} />
          <Route path="/widerruf" element={<PublicSite><Widerruf /></PublicSite>} />
          <Route path="/angebot" element={<PublicSite><Quote /></PublicSite>} />
          <Route path="/analyse" element={<PublicSite><AnalysisWizard /></PublicSite>} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Overview />} />
            <Route path="arama" element={<Dashboard />} />
            <Route path="gelen-kutusu" element={<Inbox />} />
            <Route path="siparisler" element={<Orders />} />
            <Route path="hizmetler" element={<Services />} />
            <Route path="indirim-kodlari" element={<Discounts />} />
            <Route path="eksik-olcumler" element={<Backfill />} />
            <Route path="anahtar-kelimeler" element={<KeywordSets />} />
            <Route path="sayfalar" element={<Pages />} />
            <Route path="yorumlar" element={<Testimonials />} />
          </Route>
          <Route path="/rapor/:token" element={<ReportPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
